import { useSetAtom } from "jotai";

import { $importTemplatePages } from "../../internal/templates";

export const useImportTemplatePages = () => {
	const importTemplatePages = useSetAtom($importTemplatePages);

	return importTemplatePages;
};
